import React, { useState } from "react";
import { Navbar, Image, Container, Row, Col } from "react-bootstrap";
import "./index.css";
import morgannav from "../../Images/navbarmorganlogo.png";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index"
export default function Header({ links }) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 20) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <Container>
      <Navbar expand="lg"
        fixed="top"
        bg="dark"
        variant="dark"
        className={navbar ? 'navbar active' : 'navbar'}>
        <Container>
          <Row className="headerlogos">
            <Col xl={6}>
              <a href="https://www.swmc.com/" target="_blank">
                <Image src={"https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"}
                  alt="Sun West logo" title="Sun West logo" className="sunwest-logo mt-2" />
              </a>
            </Col>
            <Col xl={5}>
              <a href="https://angelai.com/" target="_blank">
                <Image src='https://resources.swmc.com/angel-ai/brandnameflipwithlogostatic.gif'
                  alt="Angel Ai logo" title="morgan-logo" className="morgan-university-logo mt-2" />
              </a>
            </Col>
          </Row>
          <div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="black" width={40} height={40} />
          </div>
        </Container>
      </Navbar>
      <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="black" width={40} height={40} />
      </div>
    </Container>
  );
}